/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetOrganizationProperties200ResponseMeta } from './GetOrganizationProperties200ResponseMeta';
import {
    GetOrganizationProperties200ResponseMetaFromJSON,
    GetOrganizationProperties200ResponseMetaFromJSONTyped,
    GetOrganizationProperties200ResponseMetaToJSON,
    GetOrganizationProperties200ResponseMetaToJSONTyped,
} from './GetOrganizationProperties200ResponseMeta';
import type { PropertyLinkedOrganization } from './PropertyLinkedOrganization';
import {
    PropertyLinkedOrganizationFromJSON,
    PropertyLinkedOrganizationFromJSONTyped,
    PropertyLinkedOrganizationToJSON,
    PropertyLinkedOrganizationToJSONTyped,
} from './PropertyLinkedOrganization';

/**
 * 
 * @export
 * @interface GetPropertyOrganizations200Response
 */
export interface GetPropertyOrganizations200Response {
    /**
     * 
     * @type {Array<PropertyLinkedOrganization>}
     * @memberof GetPropertyOrganizations200Response
     */
    organizations: Array<PropertyLinkedOrganization>;
    /**
     * 
     * @type {GetOrganizationProperties200ResponseMeta}
     * @memberof GetPropertyOrganizations200Response
     */
    meta?: GetOrganizationProperties200ResponseMeta;
}

/**
 * Check if a given object implements the GetPropertyOrganizations200Response interface.
 */
export function instanceOfGetPropertyOrganizations200Response(value: object): value is GetPropertyOrganizations200Response {
    if (!('organizations' in value) || value['organizations'] === undefined) return false;
    return true;
}

export function GetPropertyOrganizations200ResponseFromJSON(json: any): GetPropertyOrganizations200Response {
    return GetPropertyOrganizations200ResponseFromJSONTyped(json, false);
}

export function GetPropertyOrganizations200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPropertyOrganizations200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'organizations': ((json['organizations'] as Array<any>).map(PropertyLinkedOrganizationFromJSON)),
        'meta': json['meta'] == null ? undefined : GetOrganizationProperties200ResponseMetaFromJSON(json['meta']),
    };
}

export function GetPropertyOrganizations200ResponseToJSON(json: any): GetPropertyOrganizations200Response {
    return GetPropertyOrganizations200ResponseToJSONTyped(json, false);
}

export function GetPropertyOrganizations200ResponseToJSONTyped(value?: GetPropertyOrganizations200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organizations': ((value['organizations'] as Array<any>).map(PropertyLinkedOrganizationToJSON)),
        'meta': GetOrganizationProperties200ResponseMetaToJSON(value['meta']),
    };
}

